<h2 mat-dialog-title>Error</h2>
<mat-dialog-content>{{data.message}}</mat-dialog-content>
<button mat-raised-button [mat-dialog-close]="true" color="accent">Ok</button>
